export default __webpack_public_path__ + "static/media/second2.da24f3af.png";